<div class="card-header bg-light">
    <h4 class="card-title mb-0">
        <i class="far fa-file"></i> {{ tituloModal }}
    </h4>
</div>

<form class="needs-validation" novalidate id="myForm" #f="ngForm">
    <div class="card-body">
        <div class="p-2 wrapper">

            <div class="row mb-2">
                <div class="col-md-2 mb-2">
                    <label class="form-label">Questão</label>
                    <input type="text" class="form-control form-control-sm" disabled placeholder="-"
                        [ngModel]="model?.identificador" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="col-md-10 mb-2">
                    <label class="form-label">Descrição</label>
                    <input type="text" class="form-control form-control-sm" disabled placeholder="-"
                        [ngModel]="model.questao ? model.questao.nome : model.descricao"
                        [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="col-md-2 mb-2">
                    <label class="form-label">Tipo</label>
                    <input type="text" class="form-control form-control-sm" disabled placeholder="-"
                        [ngModel]="model?.tipoDesc" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="col-md-2 mb-2">
                    <label class="form-label">Status</label>
                    <input type="text" class="form-control form-control-sm" disabled placeholder="-"
                        [ngModel]="model?.statusDesc" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="col-md-8 mb-2">
                    <label class="form-label">Responsável pela Última Alteração</label>
                    <input type="text" class="form-control form-control-sm" disabled placeholder="-"
                        [ngModel]="model?.responsavelNome" [ngModelOptions]="{ standalone: true }" />
                </div>
            </div>

            <div class="row mb-2">

                <div class="col-sm-4">
                    <label for="validationCustom06" class="form-label">Avaliação Consolidada</label>
                    <div class="mat-elevation-z1">
                        <table mat-table [dataSource]="dataSourceAvaliacao">

                            <tr mat-header-row *matHeaderRowDef="['descricao', 'quantidade', 'percentual']"
                                class="bg-light">
                            </tr>

                            <ng-container matColumnDef="descricao">
                                <th mat-header-cell *matHeaderCellDef>
                                    Avaliação
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="element?.avaliacaoDesc">{{element?.avaliacaoDesc }}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="quantidade">
                                <th mat-header-cell *matHeaderCellDef>
                                    Num. Ocorrências
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="element?.quantidade">{{element?.quantidade }}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="percentual">
                                <th mat-header-cell *matHeaderCellDef>
                                    Percentual %
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="element?.percentual">{{element?.percentual }}</span>
                                </td>
                            </ng-container>

                            <tr mat-row *matRowDef="let row; columns: ['descricao', 'quantidade', 'percentual']"></tr>
                        </table>
                        <h5 class="table-no-data" [hidden]="dataSourceAvaliacao.data?.length > 0">
                            Nenhuma avaliação lançada
                        </h5>
                    </div>
                </div>

                <div class="col-sm-8">
                    <label for="validationCustom06" class="form-label">Evidências Vinculadas</label>
                    <div class="mat-elevation-z1">
                        <table mat-table [dataSource]="dataSourceEvidencias" matSortDisableClear matSort
                            matSortDirection="asc">
                            <tr mat-header-row
                                *matHeaderRowDef="['nome', 'arquivo', 'link', 'justificativa']"
                                class="bg-light">
                            </tr>

                            <ng-container matColumnDef="nome">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Nome do Papel de Trabalho
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="!element?.osaExecucaoPapelTrabalho.nomePapel">-</span>
                                    <span *ngIf="element?.osaExecucaoPapelTrabalho.nomePapel">{{
                                        element.osaExecucaoPapelTrabalho.nomePapel }}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="arquivo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Arquivos</th>
                                <td mat-cell *matCellDef="let element">
                                    <a class="icon-btn btn btn-info btn-xs text-left ml-1" data-toggle="collapse"
                                        href="#collapseExample-{{element?.arquivos[0]?.id}}" role="button"
                                        aria-expanded="false">
                                        Arquivos
                                        <i class="ml-2 fas fa-file"></i>
                                    </a>

                                    <div class="collapse" id="collapseExample-{{ element.arquivos[0]?.id }}">
                                        <small *ngIf="!element?.arquivos[0]" class="ml-1"> Não possui arquivos</small>
                                        <div *ngFor="let items of element?.arquivos" class="ml-1">
                                            <div class="">
                                                <small (click)="
                                                download(items?.osaExecucaoPapelTrabalhoArquivo)
                                            " class="download">{{ items.osaExecucaoPapelTrabalhoArquivo.nome }}</small>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="link">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Link
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="!element?.osaExecucaoPapelTrabalho.link">-</span>
                                    <span *ngIf="element?.osaExecucaoPapelTrabalho.link">{{
                                        element.osaExecucaoPapelTrabalho.link }}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="justificativa">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Justificativa
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="!element?.osaExecucaoPapelTrabalho.justificativa">-</span>
                                    <span *ngIf="element?.osaExecucaoPapelTrabalho.justificativa">{{
                                        element.osaExecucaoPapelTrabalho.justificativa }}</span>
                                </td>
                            </ng-container>


                            <!-- <ng-container cdkColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    Ações
                                </th>
                                <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <button type="button" class="btn btn-danger btn-xs ml-1" title="Excluir"
                                            *ngIf="!visualizar" (click)="excluirEvidencia(element)">
                                            <i class="far fa-trash-alt"></i>
                                        </button>
                                    </div>
                                </td>
                            </ng-container> -->

                            <tr mat-row
                                *matRowDef="let row; columns: ['nome', 'arquivo', 'link', 'justificativa']">
                            </tr>
                        </table>
                        <h5 class="table-no-data" [hidden]="dataSourceEvidencias.data?.length > 0">
                            Nenhuma evidência vinculada
                        </h5>
                        <mat-paginator #tabelaPapelTrabalhoPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                            showFirstLastButtons>
                        </mat-paginator>
                    </div>
                </div>

            </div>

            <div class="row mb-2">
                <div class="col-md-4">
                    <label class="form-label">Avaliação</label>
                    <ng-select id="tipo" [readonly]="visualizar" name="avaliacao" [(ngModel)]="model.avaliacao"
                        placeholder="Selecione um critério" (ngModelChange)="verificaAlteracao()">
                        <ng-option *ngFor="let avaliacao of avaliacoesProgramaTrabalhoQuestao"
                            [value]="avaliacao.value">
                            {{ avaliacao.text }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-md-12 mt-2">
                    <label class="form-label">Observação</label>
                    <textarea class="form-control" rows="3" maxlength="500" name="observacao" [readonly]="visualizar"
                        [(ngModel)]="model.observacao" (ngModelChange)="verificaAlteracao()"
                        placeholder="Digite uma Observação"></textarea>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-sm-12">

                    <label for="validationCustom06" class="form-label">Constatações</label>

                    <div class="mat-elevation-z1">
                        <table mat-table [dataSource]="dataSourceConstatacoes" matSortDisableClear matSort
                            matSortDirection="asc">
                            <tr mat-header-row
                                *matHeaderRowDef="['identificador', 'titulo', 'tipo', 'criterio', 'risco', 'actions']"
                                class="bg-light">
                            </tr>

                            <ng-container matColumnDef="identificador">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Identificador
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="!element?.identificador">-</span>
                                    <span *ngIf="element?.identificador">{{
                                        element.identificador }}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="titulo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> 
                                    Constatação 
                                </th>
                                <td mat-cell *matCellDef="let element"> 
                                    <span 
                                        *ngIf="!element?.titulo">-
                                    </span> 
                                    <span *ngIf="element?.titulo"                                 
                                          class="texto-limitado"
                                          [matTooltip]="element?.titulo"
                                          matTooltipPosition="above">
                                        {{ element.titulo }}
                                    </span> 
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="tipo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Tipo
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="!element?.tipoDesc">-</span>
                                    <span *ngIf="element?.tipoDesc">{{
                                        element.tipoDesc }}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="criterio">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> 
                                    Critérios infringidos 
                                </th>
                                <td mat-cell *matCellDef="let element"> 
                                    <span 
                                        *ngIf="!element?.criteriosInfrigidos">-
                                    </span> 
                                    <span *ngIf="element?.criteriosInfrigidos"                                 
                                          class="texto-limitado"
                                          [matTooltip]="element?.criteriosInfrigidos"
                                          matTooltipPosition="above">
                                        {{ element.criteriosInfrigidos }}
                                    </span> 
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="risco">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Riscos associados
                                </th>
                                <td mat-cell *matCellDef="let element" style="white-space: pre-line">
                                    <span *ngIf="!element?.riscos || element.riscos.length === 0">-</span>
                                    <span *ngIf="element?.riscos && element.riscos.length > 0">
                                        {{ montarRiscos(element.riscos) }}
                                    </span>
                                </td>
                            </ng-container>

                            <ng-container cdkColumnDef="actions">

                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    <button type="button" class="btn btn-success btn-sm"
                                        (click)="modalAdicionarConstatacao()" title="Adicionar" *ngIf="!visualizar">
                                        <i class="fas fa-plus"></i>
                                        Adicionar
                                    </button>
                                </th>

                                <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <button type="button" class="btn btn-primary btn-xs ml-1" title="Alterar"
                                            *ngIf="!visualizar" (click)="modalAlterarConstatacao(element)">
                                            <i class="fas fa-pen"></i>
                                        </button>

                                        <button type="button" class="btn btn-info btn-xs ml-1" title="Visualizar"
                                            (click)="modalVisualizarConstatacao(element)">
                                            <i class="far fas fa-eye"></i>
                                        </button>

                                        <button type="button" class="btn btn-danger btn-xs ml-1" title="Excluir"
                                            *ngIf="!visualizar" (click)="excluirConstatacao(element)">
                                            <i class="far fa-trash-alt"></i>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-row
                                *matRowDef="let row; columns: ['identificador', 'titulo', 'tipo', 'criterio', 'risco', 'actions']">
                            </tr>
                        </table>
                        <h5 class="table-no-data" [hidden]="dataSourceConstatacoes.data?.length > 0">
                            Nenhuma constatação vinculada
                        </h5>
                        <mat-paginator #tabelaConstatacaoPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                            showFirstLastButtons>
                        </mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card-footer">
        <div class="d-flex w-100 justify-content-between align-items-center">
            <div class="list1">
                <button type="button" class="btn btn-default btn-sm mr-1" (click)="fechar()">
                    <i class="fas fa-times"></i> Fechar
                </button>
            </div>
            <div class="list2" *ngIf="!visualizar">
                <button class="btn btn-primary btn-sm mr-1" (click)="salvar(false)">
                    <i class="far fa-save"></i> Salvar
                </button>
                <button *ngIf="!visualizar" type="button" class="btn btn-warning btn-sm mr-1" (click)="finalizar()"
                    [disabled]="!habilitaFinalizar || model?.status === 2">
                    <i class="fas fa-check"></i> Finalizar
                </button>
            </div>
        </div>
    </div>
</form>